// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/mixture-control.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/mixture-control/mixture-control.js';

mount([g0]);
